module.exports = Object.assign;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@stamp/core/assign.js
// module id = 47
// module chunks = 0